var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { providers, provider } from 'helpers/Providers';
import { Icon } from 'elements';
import Icomoon from '../elements/Icomoon';
const logo = {
    width: 88.5,
    height: 20
};
const powered = {
    width: 45,
    height: 5
};
class Logo extends Component {
    render() {
        const _a = this.props, { width: _width } = _a, props = __rest(_a, ["width"]);
        const width = _width || 200;
        if (provider === providers.redsys)
            return React.createElement("img", Object.assign({}, props, { width: width, src: "/assets/images/redsys.png" }));
        const logoHeight = logo.height * width / logo.width;
        const poweredHeight = powered.height * width / logo.width;
        return (React.createElement(Wrapper, Object.assign({}, props),
            React.createElement(StyledLogo, { name: "logo", size: logoHeight - 15 })));
    }
}
export default Logo;
const Wrapper = cxs('div')({
    textAlign: 'right'
});
const icon = {
    display: 'block !important',
    padding: 0
};
const StyledLogo = cxs(Icomoon)(Object.assign(Object.assign({}, icon), { color: Theme.color.primary }));
const StyledPowered = cxs(Icon)(({ size }) => (Object.assign(Object.assign({}, icon), { color: Theme.color.primary, marginTop: Theme.common.size.space * size / 20 + 'px' })));
const StyledCreanimund = cxs('label')(({ size }) => (Object.assign(Object.assign({}, icon), { marginTop: Theme.common.size.space * size / 20 + 'px' })));



//////////////////
// WEBPACK FOOTER
// ./src/components/Logo.tsx
// module id = 496
// module chunks = 0